import gql from "graphql-tag";

export const DeleteWorktableAgreement = gql`
  mutation DeleteWorktableAgreement($worktableAgreementId: String!) {
    deleteWorktableAgreement(worktableAgreementId: $worktableAgreementId)
  }
`;
